import AllCellComponentsSpecialProps from 'app/Apps/DomainObject/ComponentMapper'
import {
    FilteredBaseColumn,
} from 'app/types/richtable.types'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'

export type ExcludedConfigs = {
    tableControls?: TableControlTypes[]
}

export type SkyNetTableTab<T = {}> = {
    name: string,
    url: string,
    namedQuery?: string,
    isNamedQueryByUrl?: boolean,
    requestUrl?:string,
    customUrl?: string, // use it when whe have different domains in one table (e.g. Rate Cards)
    fields: SkyNetTableField<T>[]
    formTabs?: SidebarTab[]
    includeFilters?: Record<string, any>, // to pass filters as includeFilters: {} to request body
    filters?: Record<string, any>, // to pass filters as filters: {} to request body
    defaultTab?: boolean, // tab to be active by default
    exclude?: ExcludedConfigs
}

export type SkyNetTableTabWithLabel = SkyNetTableTab & {label: string}

export type SkyNetTableBase = {
    labelEntityName?: string,
    config?: () => any,
    name?: string,
}
export type SkyNetTableConfigWithTabs<T = {}> = SkyNetTableBase & {tabs: SkyNetTableTab<T>[]}
export type SkyNetTableConfigNoTabs<T = {}> = SkyNetTableBase & {fields: SkyNetTableField<T>[]}
export type SkyNetTableConfig<T = {}> = SkyNetTableConfigWithTabs<T> | SkyNetTableConfigNoTabs<T>

export type SidebarTab = {
    url: string,
    label: string,
    params?: string,
    Component?: (props: any) => JSX.Element,
    condition?: (data: any)=> boolean,
    activeComparer?: (pathname: string, tabUrl: string)=> boolean,
}

type SkyNetTableFieldPropsMapper = {
    lowerTempBoundary?: string,
    higherTempBoundary?: string,
    link?: string,
}

export enum RangeType {
    TemperatureRange = 'temperatureRange',
    DayRange = 'dayRange'
}

type SkyNetTableFieldBase<T = {}> = {
    id?: string,
    name?: T,
    reduced?: boolean,
    width?: string,
    minWidth?: string,
    propsMapper?: SkyNetTableFieldPropsMapper,
    sorting?: boolean,
    alignTextRight?: boolean,
    mapCellProps?: string | ((props: Record<string, any>) => Record<string, any>),
    Cell?: (props: Record<string, any>)=> JSX.Element,
    labelKey?: string,
    fxRateType?: string,
    isHidden?: boolean,
} & FilteredBaseColumn

export type SkyNetTableField<T = {}> = SkyNetTableFieldBase<T> & AllCellComponentsSpecialProps

// sort type for sort obj used in SkyNetTable
export type SkyNetTableSort = {
    field: string,
    direction: 'asc' | 'desc',
}
